// extracted by mini-css-extract-plugin
export default {"headerBar":"SharedDecisions_headerBar__G38k2"};